import { Injectable } from '@angular/core';
import { HttpContext, HttpContextToken, HttpRequest } from '@angular/common/http';
import {Subject} from "rxjs";

/**
 * Soustrait une requête à l'annulation des requêtes en cours lors d'une navigation.
 * Pour un appel dont l'issue pilote autre chose que la page courante (fenêtre
 * surgissante de connexion…) : annulé, il ne renvoie ni réponse ni erreur et laisse
 * l'appelant en attente indéfiniment.
 */
export const HORS_ANNULATION_NAVIGATION = new HttpContextToken<boolean>(() => false);

/** Contexte HttpClient d'une requête à ne pas annuler lors d'une navigation. */
export function horsAnnulationNavigation(context = new HttpContext()): HttpContext {
  return context.set(HORS_ANNULATION_NAVIGATION, true);
}

@Injectable({
  providedIn: 'root'
})
export class HttpRequestTrackerService {
  private cancelPendingRequests$ = new Subject<void>()

  public cancelPendingRequests() {
    this.cancelPendingRequests$.next()
  }

  public onCancelPendingRequests() {
    return this.cancelPendingRequests$.asObservable()
  }

  public estHorsAnnulation(req: HttpRequest<unknown>): boolean {
    return req.context.get(HORS_ANNULATION_NAVIGATION);
  }
}
